import 'react';
import { jsx } from 'react/jsx-runtime';

function SvgFacebookMono(props) {
  return /*#__PURE__*/jsx("svg", {
    width: "24",
    height: "20",
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /*#__PURE__*/jsx("path", {
      d: "M11.7446 2.20413C12.5566 2.19683 13.3683 2.20125 14.1804 2.20157C14.1836 3.0582 14.1838 3.91515 14.1801 4.77174C13.6553 4.77081 13.1301 4.77302 12.6053 4.77081C12.2725 4.75008 11.9309 5.00233 11.8703 5.33221C11.8624 5.9054 11.8675 6.47891 11.8678 7.05213C12.6375 7.0553 13.4072 7.05117 14.1768 7.05406C14.1205 7.88326 14.0176 8.70869 13.897 9.53091C13.2171 9.53729 12.5369 9.53027 11.857 9.53444C11.8509 11.9801 11.8602 14.4258 11.8523 16.8714C10.8424 16.8755 9.83201 16.8695 8.82222 16.8743C8.8031 14.4283 8.82379 11.9811 8.81172 9.53476C8.31906 9.52963 7.82612 9.53829 7.3335 9.53063C7.33538 8.7084 7.33414 7.88622 7.33442 7.06428C7.82672 7.05826 8.31938 7.06556 8.81172 7.06079C8.82668 6.26147 8.79672 5.46122 8.82732 4.66257C8.87668 4.03008 9.11774 3.39286 9.59063 2.95597C10.1629 2.4111 10.9767 2.22707 11.7446 2.20413Z",
      fill: "#42526E"
    })
  });
}

export { SvgFacebookMono as default };
